<div class="template-editor-container">
  <div class="editor-layout">
    <div class="main-content">
      @if (showProcessingStatus) {
        <div class="readonly-status-bar">
          <mat-icon class="spinning-icon">sync</mat-icon>
          <span>{{ 'TEMPLATES.EDITOR.READONLY_STATUS' | translate }}</span>
        </div>
      } @else {
        <div class="top-menu" #topMenu>
          <div class="menu-actions">
            @if (!readonly && isActive('INDENT')) {
              <span [matTooltip]="'TEMPLATES.EDITOR.INDENT' | translate" [matTooltipShowDelay]="0">
                <button mat-icon-button (click)="indentItem()" [disabled]="!canIndent()">
                  <mat-icon>chevron_right</mat-icon>
                </button>
              </span>
            }
            @if (!readonly && isActive('OUTDENT')) {
              <span [matTooltip]="'TEMPLATES.EDITOR.OUTDENT' | translate" [matTooltipShowDelay]="0">
                <button mat-icon-button (click)="outdentItem()" [disabled]="!canOutdent()">
                  <mat-icon>chevron_left</mat-icon>
                </button>
              </span>
            }
            @if (!readonly && isActive('ADD_ITEM')) {
              <button mat-icon-button (click)="addNewItem()" [matTooltip]="'TEMPLATES.EDITOR.ADD_ITEM' | translate" [matTooltipShowDelay]="0">
                <mat-icon>add</mat-icon>
              </button>
            }
            @if (!readonly && isActive('ADD_SUB_ITEM')) {
              <span [matTooltip]="'TEMPLATES.EDITOR.ADD_SUB_ITEM' | translate" [matTooltipShowDelay]="0">
                <button mat-icon-button (click)="addSubItem()" [disabled]="!selectedItemId">
                  <mat-icon>subdirectory_arrow_right</mat-icon>
                </button>
              </span>
            }
            @if (!readonly && isActive('REMOVE')) {
              <span [matTooltip]="'TEMPLATES.EDITOR.REMOVE' | translate" [matTooltipShowDelay]="0">
                <button mat-icon-button class="remove-button" (click)="removeItem()" [disabled]="!selectedItemId">
                  <mat-icon>delete</mat-icon>
                </button>
              </span>
            }
            @if (!readonly && (isActive('EXPAND_ALL') || isActive('COLLAPSE_ALL'))) {
              @if (hasAnyExpandedItems) {
                <button mat-icon-button (click)="collapseAll()" [matTooltip]="'TEMPLATES.EDITOR.COLLAPSE_ALL' | translate" [matTooltipShowDelay]="0">
                  <mat-icon>unfold_less</mat-icon>
                </button>
              } @else {
                <button mat-icon-button (click)="expandAll()" [matTooltip]="'TEMPLATES.EDITOR.EXPAND_ALL' | translate" [matTooltipShowDelay]="0">
                  <mat-icon>unfold_more</mat-icon>
                </button>
              }
            }
            @if (!readonly && isActive('DUPLICATE')) {
              <span [matTooltip]="'TEMPLATES.EDITOR.DUPLICATE' | translate" [matTooltipShowDelay]="0">
                <button mat-icon-button (click)="duplicateItem()" [disabled]="!selectedItemId">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </span>
            }
            @if (!readonly && displayMenuButton) {
              <button mat-icon-button [matMenuTriggerFor]="overflowMenu" class="overflow-menu-button">
                <mat-icon>more_vert</mat-icon>
              </button>
            }
            <mat-menu #overflowMenu="matMenu">
              @if (!isActive('INDENT')) {
                <button mat-menu-item (click)="indentItem()" [disabled]="!canIndent()">
                  <mat-icon>chevron_right</mat-icon>
                  <span>{{ 'TEMPLATES.EDITOR.INDENT' | translate }}</span>
                </button>
              }
              @if (!isActive('OUTDENT')) {
                <button mat-menu-item (click)="outdentItem()" [disabled]="!canOutdent()">
                  <mat-icon>chevron_left</mat-icon>
                  <span>{{ 'TEMPLATES.EDITOR.OUTDENT' | translate }}</span>
                </button>
              }
              @if (!isActive('ADD_ITEM')) {
                <button mat-menu-item (click)="addNewItem()">
                  <mat-icon>add</mat-icon>
                  <span>{{ 'TEMPLATES.EDITOR.ADD_ITEM' | translate }}</span>
                </button>
              }
              @if (!isActive('ADD_SUB_ITEM')) {
                <button mat-menu-item (click)="addSubItem()" [disabled]="!selectedItemId">
                  <mat-icon>add</mat-icon>
                  <span>{{ 'TEMPLATES.EDITOR.ADD_SUB_ITEM' | translate }}</span>
                </button>
              }
              @if (!isActive('REMOVE')) {
                <button mat-menu-item (click)="removeItem()" [disabled]="!selectedItemId">
                  <mat-icon>delete</mat-icon>
                  <span>{{ 'TEMPLATES.EDITOR.REMOVE' | translate }}</span>
                </button>
              }
              @if (!readonly && !isActive('EXPAND_ALL') && !isActive('COLLAPSE_ALL')) {
                @if (hasAnyExpandedItems) {
                  <button mat-menu-item (click)="collapseAll()">
                    <mat-icon>unfold_less</mat-icon>
                    <span>{{ 'TEMPLATES.EDITOR.COLLAPSE_ALL' | translate }}</span>
                  </button>
                } @else {
                  <button mat-menu-item (click)="expandAll()">
                    <mat-icon>unfold_more</mat-icon>
                    <span>{{ 'TEMPLATES.EDITOR.EXPAND_ALL' | translate }}</span>
                  </button>
                }
              }
              @if (!isActive('DUPLICATE')) {
                <button mat-menu-item (click)="duplicateItem()" [disabled]="!selectedItemId">
                  <mat-icon>content_copy</mat-icon>
                  <span>{{ 'TEMPLATES.EDITOR.DUPLICATE' | translate }}</span>
                </button>
              }
              @if (!isActive('LOAD_TEMPLATE')) {
                <button mat-menu-item (click)="loadExistingTemplate()">
                  <mat-icon>folder_open</mat-icon>
                  <span>{{ 'TEMPLATES.EDITOR.LOAD_TEMPLATE' | translate }}</span>
                </button>
              }
            </mat-menu>
          </div>
          <div class="save-actions">
            @if (!readonly && isActive('LOAD_TEMPLATE')) {
              <span [matTooltip]="'TEMPLATES.EDITOR.LOAD_TEMPLATE' | translate" [matTooltipShowDelay]="0">
                <button mat-icon-button (click)="loadExistingTemplate()">
                  <mat-icon>folder_open</mat-icon>
                </button>
              </span>
            }
            @if (!readonly && _templateItems.length > 0) {
              <span [matTooltip]="'TEMPLATES.EDITOR.SAVE_AS' | translate" [matTooltipShowDelay]="0">
                <button mat-icon-button (click)="saveAsTemplate()">
                  <mat-icon>save_as</mat-icon>
                </button>
              </span>
            }
            @if (!readonly) {
              @if (isSaving) {
                <mat-icon class="save-status-icon spinning-icon" [matTooltip]="'TEMPLATES.EDITOR.SAVING' | translate" [matTooltipShowDelay]="0">sync</mat-icon>
              } @else if (hasUnsavedChanges) {
                <mat-icon class="save-status-icon unsaved-icon" [matTooltip]="'TEMPLATES.EDITOR.UNSAVED' | translate" [matTooltipShowDelay]="0"
                  >cloud_off</mat-icon
                >
              } @else if (showSavedIndicator) {
                <mat-icon class="save-status-icon saved-icon" [matTooltip]="'TEMPLATES.EDITOR.SAVED' | translate" [matTooltipShowDelay]="0"
                  >check_circle</mat-icon
                >
              }
            }
          </div>
        </div>
      }

      <div class="content-wrapper" (click)="deselectItem($event)">
        <div class="items-container" cdkDropList [cdkDropListDisabled]="readonly" (cdkDropListDropped)="onItemDrop($event)">
          @for (item of flattenedItems; track item.id) {
            <app-template-item
              [item]="item"
              [availableResources]="availableResources"
              [allowFileUpload]="allowFileUpload"
              [selectedItemId]="selectedItemId"
              [attendeeNames]="attendeeNames"
              [systemGuidanceEditingEnabled]="systemGuidanceEditingEnabled"
              [readonly]="readonly"
              [defaultLevelOfDetail]="defaultLevelOfDetail"
              [defaultAnonymization]="defaultAnonymization"
              (itemSelected)="selectItem($event)"
              (contentChanged)="markAsChanged()"
              (contentChangedInstant)="markAsChangedInstant()"
              (fileUploadRequested)="fileUploadRequested.emit($event)"
              (pdfPreviewRequested)="openPdfPreview($event)"
            />
          }
        </div>
      </div>
    </div>
  </div>
</div>
